import React from "react";
import { Link } from "react-router-dom";
import ArrowRightIcon from "../../assets/svg/arrow-right-white.svg";

const GetInTouch = () => {
    return (
        <section className="customize-your-wheat get-in-touch">
            <div className="customize-box">

                <h2 className="fs_40 text-white fw_700 mb_20">
                    Let's Build a Healthier Future Together
                </h2>

                <p className="fs_20 fw_400 text-white mb_30 lh-1-5">
                    Whether you have questions about our freshly milled flour,
                    need help customizing your perfect atta blend, or want
                    assistance with your order, our team is always happy to help.
                    At Moolchandji Foods, every customer is family, and we're
                    committed to providing you with the freshest, healthiest,
                    and highest-quality flour possible.
                </p>

                <Link
                    to="/contact-us"
                    className="d-inline-flex align-items-center text-white text-uppercase fw_600 fs_20 text-decoration-none button btn-outline-white"
                >
                    Contact Our Team
                    <img
                        className="img-fluid ml_12"
                        src={ArrowRightIcon}
                        alt="Arrow"
                    />
                </Link>

            </div>
        </section>
    );
};

export default GetInTouch;